import React from 'react';
import Icon from '../../../components/AppIcon';

const BillSummaryCard = ({ billData }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    })?.format(amount);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6 shadow-elevation-1 min-w-0 w-full">
      {/* Restaurant Header */}
      <div className="flex items-start justify-between mb-6">
        <div className="flex-1">
          <h2 className="text-xl font-semibold text-foreground mb-1 break-words">
            {billData?.restaurant?.name}
          </h2>
          <p className="text-sm text-text-secondary mb-2">
            {billData?.restaurant?.address}
          </p>
          <div className="flex items-center space-x-4 text-sm text-text-secondary">
            <div className="flex items-center space-x-1">
              <Icon name="MapPin" size={14} />
              <span>Mesa {billData?.tableNumber}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Calendar" size={14} />
              <span>{formatDate(billData?.date)}</span>
            </div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-sm text-text-secondary mb-1 break-words">Ticket #{billData?.ticketNumber}</div>
          <div className="text-lg font-semibold text-foreground font-mono">
            {formatCurrency(billData?.total)}
          </div>
        </div>
      </div>
      {/* Bill Status */}
      <div className="flex items-center justify-between p-3 bg-muted rounded-lg mb-6">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse-soft" />
          <span className="text-sm font-medium text-foreground">
            Cuenta activa para división
          </span>
        </div>
        <div className="text-xs text-text-secondary">
          Expira en 45 min
        </div>
      </div>
      {/* Quick Stats */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="text-center p-3 bg-muted/50 rounded-lg">
          <div className="text-lg font-semibold text-foreground font-mono">
            {billData?.items?.length}
          </div>
          <div className="text-xs text-text-secondary">Artículos</div>
        </div>
        <div className="text-center p-3 bg-muted/50 rounded-lg">
          <div className="text-lg font-semibold text-foreground font-mono">
            {billData?.participants?.length}
          </div>
          <div className="text-xs text-text-secondary">Comensales</div>
        </div>
        <div className="text-center p-3 bg-muted/50 rounded-lg">
          <div className="text-lg font-semibold text-foreground font-mono">
            {formatCurrency(billData?.total / billData?.participants?.length)}
          </div>
          <div className="text-xs text-text-secondary">Por persona</div>
        </div>
      </div>
      {/* Total Breakdown */}
      <div className="space-y-2 pt-4 border-t border-border">
        <div className="flex justify-between text-sm">
          <span className="text-text-secondary">Subtotal</span>
          <span className="font-mono text-foreground">{formatCurrency(billData?.subtotal)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-text-secondary">IVA (21%)</span>
          <span className="font-mono text-foreground">{formatCurrency(billData?.tax)}</span>
        </div>
        {billData?.serviceCharge > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-text-secondary">Servicio</span>
            <span className="font-mono text-foreground">{formatCurrency(billData?.serviceCharge)}</span>
          </div>
        )}
        <div className="flex justify-between text-base font-semibold pt-2 border-t border-border">
          <span className="text-foreground">Total</span>
          <span className="font-mono text-foreground">{formatCurrency(billData?.total)}</span>
        </div>
      </div>
    </div>
  );
};

export default BillSummaryCard;